import jquery__WEBPACK from "jquery";
import select2 from "select2";

//__webpack_require__.r(__webpack_exports__);
///* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
///* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
///* harmony import */ var select2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! select2 */ "./node_modules/select2/dist/js/select2.js");
///* harmony import */ var select2__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(select2__WEBPACK_IMPORTED_MODULE_1__);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

//__webpack_require__(/*! select2/src/scss/core.scss */ "./node_modules/select2/src/scss/core.scss");
/* harmony default export */ __webpack_exports__["default"] = ((function () {
  var $html = jquery__WEBPACK('html');
  var defaultOpenFirstDropDown = true;
  var ExecutiveStyleQuizGC = {
    currentStep: 0,
    totalSteps: 6,
    hasSelect2Active: false,
    init: function init() {
      this.choseLifeStyle = [];
      this.$container = jquery__WEBPACK('.quiz--giftcard--executive');
      this.$form = jquery__WEBPACK('form', this.$container);
      this.$drawer = jquery__WEBPACK('.quiz__drawer', this.$container);
      this.$prevBtn = jquery__WEBPACK('.js-prevstep', this.$container);
      this.$nextBtn = jquery__WEBPACK('.js-nextstep', this.$container);
      this.goToStep(1);
      this.loadSessionData();
      this.onFormChanged();
      this.initEventHandlers();
      this.allowUserToUncheckRadioInputs();
      this.initOrDestroySelect2();
      if (window.location.search.indexOf('redeemexecgift=true') > -1) {
        this.show();
      }
    },
    allowUserToUncheckRadioInputs: function allowUserToUncheckRadioInputs() {
      var _this = this;
      var self = this;
      var choseLifeStyle = [];
      jquery__WEBPACK('[type="radio"] + label', this.$container).click(function () {
        var target = jquery__WEBPACK(this).attr('for');
        var styleValue = jquery__WEBPACK(this).attr("id");
        var parent_element = jquery__WEBPACK(this).closest(".quiz__step.is-active").attr('data-for-step');
        if (parent_element.includes('2')) {
          if (choseLifeStyle.length > 0) {
            choseLifeStyle[0] = styleValue;
          } else {
            choseLifeStyle.push(styleValue);
          }
        } else if (parent_element.includes('3')) {
          if (choseLifeStyle.length > 1) {
            choseLifeStyle[1] = styleValue;
          } else {
            choseLifeStyle.push(styleValue);
          }
        } else if (parent_element.includes('4')) {
          if (choseLifeStyle.length > 2) {
            choseLifeStyle[2] = styleValue;
          } else {
            choseLifeStyle.push(styleValue);
          }
        }
        self.choseLifeStyle = _toConsumableArray(choseLifeStyle);
        if (parent_element.includes('5')) {
          var styleSortedArray = _toConsumableArray(choseLifeStyle).sort();
          var choseLifeStyleDuplicate = [];
          for (var i = 0; i < styleSortedArray.length - 1; i++) {
            if (styleSortedArray[i + 1] == styleSortedArray[i]) {
              choseLifeStyleDuplicate.push(styleSortedArray[i]);
            }
          }
        }
        var $radio = jquery__WEBPACK("#".concat(target));
        if ($radio[0].checked == true) {
          setTimeout(function () {
            $radio[0].checked = false;
            self.onFormChanged();
          }, 0);
        }
      });
      jquery__WEBPACK(document).on('click', '.quiz__drawer-content .retake_quiz_text .retake_quiz_link', function (e) {
        choseLifeStyle = [];
        _this.goToStep(2);
      });
    },
    initEventHandlers: function initEventHandlers() {
      var self = this;
      jquery__WEBPACK(window).resize(this.onResized.bind(this));
      this.$form.on('change', this.onFormChanged.bind(this));
      jquery__WEBPACK('a[href*="pages/redeem-executive-gift"]').click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        if ($html.hasClass("quiz-open") === false) {
          if (window.innerWidth <= 749) {
            let topContainer = 0;
            if (document.querySelector('.shopify-section-group-header-group')) {
              topContainer += document.querySelector('.shopify-section-group-header-group').offsetHeight;
            }
            if (document.querySelector('.section-header.shopify-section-group-header-group')) {
              if (document.querySelector('.section-header.shopify-section-group-header-group.scrolled-past-header')) {
                topContainer = document.querySelector('.section-header.shopify-section-group-header-group').offsetHeight;
              } else {
                topContainer += document.querySelector('.section-header.shopify-section-group-header-group').offsetHeight;
              }
            }
            if (topContainer !== 0) {
              document.querySelector('.style-quiz-container.quiz--giftcard--executive').style.top = topContainer + 'px';
            } else {
              document.querySelector('.style-quiz-container.quiz--giftcard--executive').style.top = '';
            }
          } else {
            document.querySelector('.style-quiz-container.quiz--giftcard--executive').style.top = '';
          }
          $html.removeClass("nav-open");
          self.show();
        } else {
          self.hide();
        };
      });
      jquery__WEBPACK('.style-quiz-bg').click(function () {
        self.hide();
      });
      jquery__WEBPACK('.js-nextstep', this.$container).click(function (e) {
        e.preventDefault();
        var stepInt = parseInt(self.currentStep);
        if (stepInt > 1 && stepInt == self.totalSteps) {
          self.addToBag();
        } else {
          self.nextStep();
        }
      });
      jquery__WEBPACK('.js-prevstep', this.$container).click(function (e) {
        e.preventDefault();
        self.prevStep();
      });
      jquery__WEBPACK('.quiz__select', this.$form).click(function () {
        if (self.hasSelect2Active) {
          jquery__WEBPACK('select', this).select2('open');
        }
      });
      jquery__WEBPACK("select", this.$form).change(function () {
        var currentParent = jquery__WEBPACK(this).parents(".quiz__select");
        var nextEle = currentParent.nextAll();
        var prevEle = currentParent.prevAll();
        var flag = true;
        if (nextEle.length > 0) {
          nextEle.map(function (i, item) {
            var classes = jquery__WEBPACK(item).attr("class");
            if (!classes.includes('is-complete') && flag) {
              flag = false;
              jquery__WEBPACK('select', item).select2("open");
            }
          });
        }
        if (flag && prevEle.length > 0) {
          prevEle.map(function (i, item) {
            var classes = jquery__WEBPACK(item).attr("class");
            if (!classes.includes('is-complete') && flag) {
              flag = false;
              jquery__WEBPACK('select', item).select2("open");
            }
          });
        }
        if (flag) {
          currentParent.addClass('is-complete');
          var currentStep = jquery__WEBPACK(".quiz__modal.quiz--giftcard--executive").attr("data-current-step");
          self.goToStep(currentStep);
        }
      });
      jquery__WEBPACK('select', this.$form).on('select2:open', function (e) {
        jquery__WEBPACK('.select2-dropdown').hide().fadeIn(200);
      });
    },
    selectDefaultQuizOption: function selectDefaultQuizOption(parentEle) {
      var styleSortedArray = _toConsumableArray(this.choseLifeStyle).sort();
      var choseLifeStyleDuplicate = [];
      for (var i = 0; i < styleSortedArray.length - 1; i++) {
        if (styleSortedArray[i + 1] == styleSortedArray[i]) {
          choseLifeStyleDuplicate.push(styleSortedArray[i]);
        }
      }
      parentEle.querySelectorAll('input').forEach(function (ele) {
        if (choseLifeStyleDuplicate.length > 0) {
          if (ele.value === choseLifeStyleDuplicate[0]) {
            ele.checked = true;
            ele.labels[0].classList.add('active-style');
            ele.labels[0].classList.remove('hide');
          } else {
            ele.labels[0].classList.remove('active-style');
            ele.labels[0].classList.add('hide');
          }
        } else {
          if (ele.value === 'All Styles') {
            ele.checked = true;
            ele.labels[0].classList.add('active-style');
            ele.labels[0].classList.remove('hide');
          } else {
            ele.labels[0].classList.remove('active-style');
            ele.labels[0].classList.add('hide');
          }
        }
      });
    },
    onFormChanged: function onFormChanged() {
      this.updateSelectInputStatus();
      this.updateNextButtonStatus();
      this.updateDrawer();
    },
    onResized: function onResized() {
      if ($html.hasClass("executive-gc-quiz-open")) {
        this.updateDrawer();
        this.goToStep(this.currentStep);
        this.initOrDestroySelect2();
      }
    },
    sendAnalytics: function sendAnalytics(action) {
      try {
        ga('send', 'event', {
          eventCategory: 'GCStyleQuiz',
          eventAction: action
        });
        fbq('track', 'ViewContent', {
          content_name: action,
          content_category: 'GCStyleQuiz'
        });
      } catch (e) {
        console.log('Error logging GCStyleQuiz event', e);
      }
    },
    sendStepAnalytics: function sendStepAnalytics() {
      var stepNames = {
        '1': 'StepMonths',
        '2': 'StepStyle',
        '3': 'StepStyle',
        '4': 'StepStyle',
        '5': 'StepStyle',
        '6': 'StepSizes'
      };
      if ($html.hasClass('executive-gc-quiz-open')) {
        this.sendAnalytics(stepNames[this.currentStep]);
      }
    },
    show: function show() {
      $html.addClass('executive-gc-quiz-open');
      this.updateDrawer();
      this.sendAnalytics('Opened');
      this.sendStepAnalytics();
    },
    hide: function hide() {
      $html.removeClass('executive-gc-quiz-open');
      this.sendAnalytics('Closed');
    },
    initOrDestroySelect2: function initOrDestroySelect2() {
      var isMobile = jquery__WEBPACK(window).width() < 768;
      var $selects = jquery__WEBPACK("select", this.$form);
      if (this.hasSelect2Active == false) {
        $selects.select2({
          minimumResultsForSearch: Infinity,
          width: "100%"
        });
        $selects.addClass("hide");
        this.hasSelect2Active = true;
      }
    },
    refreshSelect2: function refreshSelect2() {
      var $selects = jquery__WEBPACK('select', this.$form);
      if (!this.hasSelect2Active) {
        return;
      }
      $selects.select2('destroy');
      this.hasSelect2Active = false;
      this.initOrDestroySelect2();
    },
    updateSelectInputStatus: function updateSelectInputStatus() {
      var $selects = jquery__WEBPACK('select', this.$form);
      jquery__WEBPACK.each($selects, function () {
        var $select = jquery__WEBPACK(this);
        var $label = $select.parents('.quiz__select');
        if (!$select.val()) {
          $label.removeClass('is-complete');
        } else {
          $label.addClass('is-complete');
        }
      });
    },
    updateNextButtonStatus: function updateNextButtonStatus(isPrev) {
      var $activeStep = jquery__WEBPACK('.quiz__step.is-active', this.$container);
      var $inputs = jquery__WEBPACK('input, select', $activeStep);
      var getStep = $activeStep.attr('data-for-step');
      getStep = parseInt(getStep) + 1;
      var stepIsComplete = true;
      jquery__WEBPACK.each($inputs, function () {
        var $input = jquery__WEBPACK(this);
        if ($input.is('[type="radio"]')) {
          var radioGroup = $input.attr('name');
          if (jquery__WEBPACK("[name=\"".concat(radioGroup, "\"]:checked"), $activeStep).length == 0) {
            stepIsComplete = false;
          }
        } else if ($input.is('select')) {
          if (!$input.val()) {
            stepIsComplete = false;
          }
        }
      });
      if (stepIsComplete) {
        this.$nextBtn.addClass('pulse').prop('disabled', false);
        if (!isPrev) {
          if (getStep <= 5 || getStep < 6) {
            this.goToStep(getStep);
          }
          var slideElement = document.querySelector('.quiz--giftcard--executive .quiz__step.step-style.is-active');
          if (slideElement && slideElement.getAttribute('data-for-step') === '5') {
            /* Select default quiz option for Step 5 */
            this.$nextBtn.addClass("pulse").prop("disabled", false);
            this.selectDefaultQuizOption(slideElement);
          }
        }
      } else {
        this.$nextBtn.removeClass('pulse').prop('disabled', true);
        var _slideElement = document.querySelector('.quiz--giftcard--executive .quiz__step.step-sizes.is-active');
        if (defaultOpenFirstDropDown) {
          if (_slideElement && _slideElement.getAttribute('data-for-step') === '6') {
            /* Select default quiz option for Step 5 */
            var firstSelect = jquery__WEBPACK('.quiz__select:first', _slideElement);
            var currentSelect = jquery__WEBPACK('select', firstSelect);
            if (!firstSelect.attr("class").includes('is-complete')) {
              setTimeout(function () {
                currentSelect.select2('open');
              }, 1000);
              defaultOpenFirstDropDown = false;
            }
          }
        }
      }
    },
    adjustOptionAvailability: function adjustOptionAvailability() {
      // Custom logic per selected box:
      // The Tour Experience box does not offer the following sizes:
      // Shirt size is XXX-Large
      // Pant waist is 42 or larger

      var userSelectedTourBox = jquery__WEBPACK("#box_tour", this.$container).is(":checked");
      var $shirtSize = jquery__WEBPACK("#shirt_size", this.$container);
      var $pantSize = jquery__WEBPACK("#pant_size", this.$container);
      if (userSelectedTourBox) {
        jquery__WEBPACK('[value*="XXX"]', $shirtSize).prop("selected", false).attr("hidden", "hidden").attr("disabled", "disabled");
        jquery__WEBPACK('[value*="42"], [value*="44"]', $pantSize).prop("selected", false).attr("hidden", "hidden").attr("disabled", "disabled");
      } else {
        jquery__WEBPACK("option:not(:first-child)", $shirtSize).removeAttr("disabled hidden");
        jquery__WEBPACK("option:not(:first-child)", $pantSize).removeAttr("disabled hidden");
      }
      this.refreshSelect2();
    },
    updateDrawer: function updateDrawer() {
      // check if this step has drawer content and slide it open/closed
      var $stepDrawerContent = jquery__WEBPACK(".quiz__drawer-content[data-for-step*=\"".concat(this.currentStep, "\"]"), this.$container);
      var $step = jquery__WEBPACK(".quiz__step[data-for-step*=\"".concat(this.currentStep, "\"]"), this.$container);
      jquery__WEBPACK('.quiz__drawer-content', this.$container).removeClass('is-showing');
      if ($stepDrawerContent.length > 0 &&
      // this step has a drawer
      jquery__WEBPACK('input:checked', $step).length > 0) {
        // has an option in this step been selected
        $stepDrawerContent.addClass('is-showing');
        this.$drawer.addClass('is-open').css('height', $stepDrawerContent.outerHeight());
      } else {
        // no drawer for this step, slide it closed
        this.$drawer.removeClass('is-open').css('height', '');
      }
      this.updateDrawerValues();
    },
    updateDrawerValues: function updateDrawerValues() {
      var $datas = jquery__WEBPACK('[data-for-value]', this.$drawer).removeClass('is-active');
      var $activeStep = jquery__WEBPACK('.quiz__step.is-active', this.$container);
      var $selectedRadio = jquery__WEBPACK('input:checked', $activeStep);
      var radioValue = $selectedRadio.val();
      jquery__WEBPACK("[data-for-value*=\"".concat(radioValue, "\"]"), this.$drawer).addClass('is-active');
    },
    goToStep: function goToStep(step, isPrev) {
      var stepInt = parseInt(step);
      jquery__WEBPACK('[data-for-step]', this.$container).removeClass('is-active');
      jquery__WEBPACK("[data-for-step*=\"".concat(step, "\"]"), this.$container).addClass('is-active');
      jquery__WEBPACK('.current-step-text', this.$container).text('0' + stepInt);
      this.currentStep = step;
      this.$form.attr('data-current-step', step);
      if (step <= 1) {
        this.$prevBtn.attr('disabled', 'disabled');
      } else {
        this.$prevBtn.removeAttr('disabled');
      }
      if (step == this.totalSteps) {
        this.$nextBtn.attr('disabled', 'disabled');
      } else {
        this.$nextBtn.removeAttr('disabled');
      }
      var slideElement = document.querySelector('.quiz--giftcard--executive .quiz__step.step-sizes.is-active');
      if (slideElement && slideElement.getAttribute('data-for-step') === '6') {
        defaultOpenFirstDropDown = true;
      }
      if ($html.hasClass('executive-gc-quiz-open')) {
        this.updateDrawer();
      }
      this.adjustOptionAvailability();
      this.updateNextButtonStatus(isPrev);
      this.sendStepAnalytics();
    },
    nextStep: function nextStep() {
      var stepInt = parseInt(this.currentStep);
      if (stepInt < this.totalSteps) {
        this.goToStep(stepInt + 1);
      }
    },
    prevStep: function prevStep() {
      var stepInt = parseInt(this.currentStep);
      if (stepInt == 2) {
        this.goToStep(1, true);
      } else if (stepInt > 2) {
        this.goToStep(stepInt - 1, true);
      }
    },
    saveSessionData: function saveSessionData() {
      var serialized = this.$form.serializeArray();
      sessionStorage.setItem('gcstylequizdata', JSON.stringify(serialized));
    },
    clearSessionData: function clearSessionData() {
      sessionStorage.removeItem('gcstylequizdata');
    },
    loadSessionData: function loadSessionData() {
      var savedData = JSON.parse(sessionStorage.getItem('gcstylequizdata'));
      jquery__WEBPACK.each(savedData, function () {
        var name = this.name,
          value = this.value;
        jquery__WEBPACK("[name=\"".concat(name, "\"]:not([type=\"radio\"]):not([type=\"checkbox\"])"), this.$container).val(value);
        jquery__WEBPACK("[name=\"".concat(name, "\"][value=\"").concat(value, "\"]"), this.$container).prop("checked", true);
      });
    },
    addToBag: function addToBag() {
      var userOptions = this.$form.serializeArray();
      var postdata = {
        'quantity': 1,
        'properties[package]': 'The Executive Package'
      };
      jquery__WEBPACK.each(userOptions, function () {
        var name = this.name,
          value = this.value;
        name = name.replace('gc_', '');
        postdata["properties[sp4_".concat(name, "]")] = value;
      });
      var IDs = {
        'Athletic': {
          '3': '39669677817946',
          '3_selling_plan': '1190559834',
          '6': '39669671166042',
          '6_selling_plan': '1209008218',
          '12': '39669660221530',
          '12_selling_plan': '1209040986'
        },
        'Loud & Wild': {
          '3': '39669689221210',
          '3_selling_plan': '1208811610',
          '6': '39669695578202',
          '6_selling_plan': '1209073754',
          '12': '39669697970266',
          '12_selling_plan': '1209106522'
        },
        'Traditional': {
          '3': '39669691383898',
          '3_selling_plan': '1190690906',
          '6': '39669696364634',
          '6_selling_plan': '1209139290',
          '12': '39669699182682',
          '12_selling_plan': '1190166618'
        },
        'All Styles': {
          '3': '39669692661850',
          '3_selling_plan': '1208942682',
          '6': '39669697282138',
          '6_selling_plan': '1209172058',
          '12': '39669699674202',
          '12_selling_plan': '1208975450'
        }
      };
      var style = postdata['properties[sp4_style]'];
      var months = postdata['properties[sp4_months]'];
      postdata['id'] = IDs[style][months];
      postdata['selling_plan'] = IDs[style][months + '_' + 'selling_plan'];

      // const self = this;

      const properties = {};
      for (const key in postdata) {
          if (key.startsWith('properties[')) {
              const propName = key.slice(11, -1);
              properties[propName] = postdata[key];
          }
      }
      const body = {
        items: [
          {
            id: postdata["id"],
            quantity: 1,
            properties: properties,
            selling_plan: postdata["selling_plan"]
          }
        ]
      };
      //console.log('properties', properties);
      this.hide();
      liquidAjaxCart.add(body, {});

      this.sendAnalytics('AddToCart');
    }
  };
  ExecutiveStyleQuizGC.init();
  window.ExecutiveStyleQuizGC = ExecutiveStyleQuizGC;
})());

//# sourceURL=webpack:///./javascript/core/style-quiz-giftcard-executive.js?
